import { useState, useEffect, useRef } from "react";
import { Wrench } from "lucide-react";

const POLL_MS = 6000;

export default function MaintenanceBanner() {
  const [data, setData] = useState(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    const apiUrl = import.meta.env.VITE_API_URL;
    if (!apiUrl) return;

    let active = true;
    const poll = async () => {
      try {
        const res = await fetch(`${apiUrl}/maintenance`);
        if (res.ok && active) setData(await res.json());
      } catch (_) {}
    };

    poll();
    intervalRef.current = setInterval(poll, POLL_MS);
    return () => { active = false; clearInterval(intervalRef.current); };
  }, []);

  if (!data?.active) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="mx-4 max-w-md w-full text-center space-y-5">
        <div className="mx-auto w-14 h-14 rounded-full bg-amber-500/20 flex items-center justify-center">
          <Wrench className="h-7 w-7 text-amber-400 animate-pulse" />
        </div>

        <h1 className="text-2xl font-bold text-white tracking-tight">
          Under Maintenance
        </h1>

        {data.message ? (
          <p className="text-gray-300 text-sm leading-relaxed">{data.message}</p>
        ) : (
          <p className="text-gray-400 text-sm leading-relaxed">
            We're making improvements. This won't take long.
          </p>
        )}

        <div className="flex items-center justify-center gap-2 pt-2">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-amber-500" />
          </span>
          <span className="text-xs text-gray-500">Checking every few seconds...</span>
        </div>
      </div>
    </div>
  );
}
